const countries = {
  ad: 'Andorra',
  ao: 'Angola',
  al: 'Albania',
  af: 'Afghanistan',
  zd: 'Algeria',
  ag: 'Antigua',
  ar: 'Argentina',
  am: 'Armenia',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bh: 'Bahrain',
  bb: 'Barbados',
  by: 'Belarus',
  be: 'Belgium',
  bz: 'Belize',
  bm: 'Bermuda',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  bo: 'Bolivia',
  br: 'Brazil',
  bn: 'Brunei',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  hr: 'Croatia',
  cl: 'Chile',
  cn: 'China',
  co: 'Colombia',
  cr: 'Costa Rica',
  cz: 'Czech Republic',
  cu: 'Cuba',
  cy: 'Cyprus',
  dk: 'Denmark',
  cd: 'Democratic Republic of Congo',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  ee: 'Estonia',
  eg: 'Egypt',
  gb_eng: 'England',
  et: 'Ethiopia',
  fi: 'Finland',
  fr: 'France',
  de: 'Germany',
  ge: 'Georgia',
  gh: 'Ghana',
  gr: 'Greece',
  gd: 'Grenada',
  gp: 'Guadeloupe',
  gt: 'Guatemala',
  gy: 'Guyana',
  ht: 'Haiti',
  hk: 'Hong Kong',
  hn: 'Honduras',
  hu: 'Hungary',
  ie: 'Ireland',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran',
  is: 'Iceland',
  iq: 'Iraq',
  il: 'Israel',
  it: 'Italy',
  ci: 'Ivory Coast',
  jm: 'Jamaica',
  jp: 'Japan',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  xk: 'Kosovo',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: 'Laos',
  lb: 'Lebanon',
  lu: 'Luxemburg',
  lv: 'Latvia',
  ly: 'Lybia',
  mq: 'Martinique',
  md: 'Moldova',
  me: 'Montenegro',
  mk: 'Macedonia',
  mg: 'Madagascar',
  my: 'Malaysia',
  ml: 'Mali',
  mv: 'Maldives',
  mt: 'Malta',
  mu: 'Mauritius',
  mx: 'Mexico',
  mn: 'Mongolia',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar',
  np: 'Nepal',
  nz: 'New Zealand',
  nl: 'Netherlands',
  ni: 'Nicaragua',
  ng: 'Nigeria',
  gb_nir: 'Northern Ireland',
  no: 'Norway',
  pa: 'Panama',
  py: 'Paraguay',
  pe: 'Peru',
  pt: 'Portugal',
  pl: 'Poland',
  ph: 'Philippines',
  pr: 'Puerto Rico',
  ro: 'Romania',
  ru: 'Russia',
  sm: 'San Marino',
  kn: 'Saint Kitts',
  lc: 'Saint Lucia',
  gb_sct: 'Scotland',
  rs: 'Serbia',
  sn: 'Senegal',
  sg: 'Singapore',
  sk: 'Slovakia',
  si: 'Slovenia',
  za: 'South Africa',
  kr: 'South Korea',
  es: 'Spain',
  lk: 'Sri Lanka',
  se: 'Sweden',
  ch: 'Switzerland',
  sd: 'Sudan',
  sr: 'Suriname',
  sy: 'Syria',
  tw: 'Taiwan',
  tz: 'Tanzania',
  th: 'Thailand',
  tt: 'Trinidad and Tobago',
  tr: 'Turkey',
  tn: 'Tunisia',
  gb: 'United Kingdom',
  us: 'USA',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  ug: 'Uganda',
  yv: 'Venezuela',
  vn: 'Vietnam',
  gb_wls: 'Wales',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};

export default countries;
